import { render, staticRenderFns } from "./TabVoyageByTrip.vue?vue&type=template&id=6a7ac77e&scoped=true"
import script from "./TabVoyageByTrip.vue?vue&type=script&lang=js"
export * from "./TabVoyageByTrip.vue?vue&type=script&lang=js"
import style0 from "./TabVoyageByTrip.vue?vue&type=style&index=0&id=6a7ac77e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7ac77e",
  null
  
)

export default component.exports